import { z } from "zod";

// Lives in shared/ (not api/cede-arena) so hub.ts can read it without pulling in
// the cede-arena barrel, which cycles back through trade-to-earn → hub.
//
// Per-user progress through the guided first battle. Mirrors the Prisma enum
// `ArenaOnboardingStatus`. NOT_STARTED/IN_PROGRESS/SKIPPED → COMPLETED (practice
// duel finished, or a legacy onboarding duel finalizing); NOT_STARTED/IN_PROGRESS
// → SKIPPED. COMPLETED is terminal.
export const ArenaOnboardingStatusSchema = z.enum(["NOT_STARTED", "IN_PROGRESS", "COMPLETED", "SKIPPED"]);
export type ArenaOnboardingStatusDto = z.infer<typeof ArenaOnboardingStatusSchema>;

// Onboarding step, projected server-side from the status: inactive | home_tour | completed.
export const ArenaOnboardingStepSchema = z.enum(["inactive", "home_tour", "completed"]);
export type ArenaOnboardingStepDto = z.infer<typeof ArenaOnboardingStepSchema>;

// Complete projection of the onboarding state for the arena client.
export const ArenaOnboardingProjectionSchema = z.object({
  step: ArenaOnboardingStepSchema,
  // Always null; kept for old arena clients until the practice-duel arena release is live.
  duelCampaignSlug: z.null(),
});
export type ArenaOnboardingProjectionDto = z.infer<typeof ArenaOnboardingProjectionSchema>;
